<template>
    <div>
        <base-crud
                crudName="Categorias de Vídeo"
                newText="Nova Categoria"
                :table="categoryVideosTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
                :enableSetStatus="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from "../Base/BaseCrud";

    export default {
        data: function () {
            return {
                categoryVideosTable: "categoryVideosTable",
                categories: [],
                pages: [],
                url: "",
                columns: ["id", "name", "photo", 'status', "actions"],
                tableData: [],
                options: {
                    sortable: ["id", "name"],
                    pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        'name': 'Nome',
                        'photo': 'Foto',
                        'actions': 'Ações'
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: "categoryVideo/"
            };
        },
        components: {
            BaseCrud
        }
    };
</script>

<style>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/CategoryVideo/Crud.vue